/**
 * Tiny helper to send custom events to GA4 via gtag.js (loaded in /public/index.html).
 * Safe no-op if gtag is not available (e.g., ad blockers).
 */
export function trackEvent(name, params = {}) {
  if (typeof window === "undefined" || typeof window.gtag !== "function") return;
  try {
    window.gtag("event", name, params);
  } catch (e) {
    // never break the UI because of analytics
    console.warn("[analytics] event failed", name, e);
  }
}
